export namespace InstitutionContractType {
  export class Enum {
    static readonly NON_REFUNDABLE = new Enum(1, 'NON_REFUNDABLE', 'Não reembolsável')

    public constructor(
      public readonly id: number,
      public readonly name: string,
      public readonly title: string
    ) {}
  }

  export const getByName = (name: string | null): Enum => {
    return Object.values(InstitutionContractType.Enum).find(i => i.name === name)
  }
}
